<template>
    <div class="my-border">
        <router-link
            type="button"
            class="btn btn-primary my-btn"
            to="./registration"
            >Edit My Availability</router-link
        >

        <div v-if="Object.keys(agendaSlots).length === 0">
            You have not selected any days yet!
        </div>

        <div v-else>
            <div v-for="(slots, day) in agendaSlots" :key="day">
                <div class="row" style="padding: 1rem 0">
                    <div class="col-xs-2">
                        <p class="text-center">{{ day }}</p>
                    </div>

                    <div class="col-xs-10">
                        <label
                            class="my-label"
                            v-for="slot in slots"
                            :key="slot.id"
                            style="padding: 0 1rem"
                        >
                            <input
                                type="checkbox"
                                :value="slot.id"
                                v-model="availableSlots"
                                disabled
                            />
                            {{ slot.start_time }}
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.my-border {
    border: 1px solid #ddd;
    padding: 0.5rem;
}
.my-label {
    font-weight: normal;
    font-size: 1.5rem;
}

p {
    font-size: 1.5rem;
}
</style>

<script>
export default {
    props: ["agendaSlots", "availableSlots"],
    computed: {
        availability() {
            const availability = {};

            for (const day in this.agendaSlots) {
                const slots = this.agendaSlots[day].filter((slot) => {
                    return this.availableSlots.includes("" + slot.id);
                });

                if (slots.length) {
                    availability[day] = slots;
                }
            }

            return availability;
        },
    },
};
</script>
